import type { Params } from "../toQueryString";
import { buildPath } from "./buildPath";

const BASE_PATH = "/internal_api/priority_inbox/threads";

export const priorityInbox = {
  threads: ({ params = {} }: { params?: Params } = {}) =>
    buildPath(BASE_PATH, params),
  unreadCount: () => buildPath(`${BASE_PATH}/unread_count`),
  read: ({ id }: { id: number }) => buildPath(`${BASE_PATH}/${id}/read`),
  solve: ({ id }: { id: number }) => buildPath(`${BASE_PATH}/${id}/solve`),
  unsolve: ({ id }: { id: number }) => buildPath(`${BASE_PATH}/${id}/unsolve`),
  dismiss: ({ id }: { id: number }) => buildPath(`${BASE_PATH}/${id}/dismiss`),
};
